<ul ngbNav #nav="ngbNav" class="nav nav-tabs dropdown-tabs nav-tabs-custom px-2 pt-1" id="notificationItemsTab">
    <li [ngbNavItem]="1" (click)="updateSearch(undefined)">
        <a ngbNavLink class="text-body">
            All
        </a>
    </li>
    <li [ngbNavItem]="2"
        (click)="updateSearchMultipleTypes([enumNotificationType.SuccessMessage,enumNotificationType.Message])">
        <a ngbNavLink class="text-body">
            Messages
        </a>
    </li>
    <li [ngbNavItem]="3" (click)="updateSearchMultipleTypes([enumNotificationType.Alert,enumNotificationType.Warning])">
        <a ngbNavLink class="text-body">
            Alerts
        </a>
    </li>
</ul>

<div class="pt-2" style="padding-left: 0.5rem; max-height: 300px; overflow: auto;" id="">
    <div *ngFor="let data of listItems">
        <div class="pe-2">
            <div class="text-reset notification-item d-block notification-hover"
                [ngClass]="{'notification-selected': data.state == true} ">
                <div class="d-flex">
                    <div class="avatar-xs me-3">
                        <span *ngIf="data.type == enumNotificationType.Message"
                            class="avatar-title bg-soft-info text-info rounded-circle fs-16">
                            <i class="bx bx-badge-check"></i>
                        </span>
                        <span *ngIf="data.type == enumNotificationType.SuccessMessage"
                            class="avatar-title bg-soft-success text-success rounded-circle fs-16">
                            <i class="bx bx-badge-check"></i>
                        </span>
                        <span *ngIf="data.type == enumNotificationType.Warning"
                            class="avatar-title bg-soft-warning text-warning rounded-circle fs-16">
                            <i class='bx bx-error-alt'></i>
                        </span>
                        <span *ngIf="data.type == enumNotificationType.Alert"
                            class="avatar-title bg-soft-danger text-danger rounded-circle fs-16">
                            <i class='bx bx-error-alt'></i>
                        </span>
                    </div>
                    <div class="flex-1">
                        <h6 class="mt-0 mb-1 fs-13 fw-semibold">{{data.subject}}</h6>
                        <div class="fs-13 text-muted" style="cursor:pointer" (click)="showText(data)">
                            <p class="mb-1"
                                [ngStyle]="{'white-space': (data.showOverFlowText == true) ? 'wrap': 'nowrap' } "
                                style="width: 350px; overflow: hidden; text-overflow: ellipsis; "
                                [innerHTML]="sanitize(data.description)">
                            </p>

                        </div>
                        <p class="mb-0 fs-11 fw-medium text-uppercase text-muted">
                            <span><i class="mdi mdi-clock-outline m-1"></i> {{data.createdDate | amTimeAgo:true}}
                                ago</span>
                        </p>
                    </div>
                    <div class="px-2 fs-15">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" name="checkAllNotifications"
                                style="cursor:pointer" (click)="stopPropagationOnClick($event)" value="{{data.id}}"
                                (change)="onCheckboxChange($event, listItems)" [(ngModel)]="data.state">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="listItems.length == 0">
        <div class="tab-pane p-4" id="alerts-tab" role="tabpanel" aria-labelledby="alerts-tab">
            <div class="w-25 w-sm-50 pt-3 mx-auto">
                <img src="assets/images/svg/bell.svg" class="img-fluid" alt="user-pic">
            </div>
            <div class="text-center pb-5 mt-2">
                <h6 class="fs-18 fw-semibold lh-base" i18n="">You have no new
                    notifications </h6>
            </div>
        </div>
    </div>
    <div *ngIf="listItems.length > 0">
        <div class="my-3 mb-4 text-center">
            <button type="button" routerLink="/operations/notifications"
                class="btn btn-soft-success waves-effect waves-light">View
                All Messages <i class="ri-arrow-right-line align-middle"></i></button>
        </div>
    </div>
</div>
<div *ngIf="checkedValGet.length > 0" class="notification-actions" id="notification-actions">
    <div class=" d-flex text-muted justify-content-center">
        Selected <div id="select-content" class="text-body fw-semibold px-1"> {{checkedValGet.length}}</div> Results
        <button type="button" class="btn link-danger p-0 ms-3 " (click)="changeReadStatusMultiple()">Mark As
            Read</button>
    </div>
</div>